import { render, staticRenderFns } from "./purchaseView.vue?vue&type=template&id=4b96db42&scoped=true"
import script from "./purchaseView.vue?vue&type=script&lang=js"
export * from "./purchaseView.vue?vue&type=script&lang=js"
import style0 from "./purchaseView.vue?vue&type=style&index=0&id=4b96db42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96db42",
  null
  
)

export default component.exports